import moment from "moment";
import decryptData from "../../../decrypt";
import { handleLogout } from "../../../config/axios";
import { apiFetch } from '../../../config/fetch';

// Helper function to detect mobile devices
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
         (window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
};

// Helper function to download file with mobile compatibility
const downloadFileWithMobileSupport = (blob: Blob, fileName: string) => {
  const blobUrl = URL.createObjectURL(blob);
  
  if (isMobileDevice()) {
    // For mobile devices, use window.open which is more reliable
    const newWindow = window.open(blobUrl, '_blank');
    if (!newWindow) {
      // If popup blocked, fallback to creating a link
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      
      // Dispatch a click event instead of calling click()
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
      link.dispatchEvent(clickEvent);
      
      // Clean up after a delay
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }, 100);
    } else {
      // Clean up blob URL after a delay
      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
      }, 1000);
    }
  } else {
    // Desktop approach
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }, 100);
  }
};

export const downloadCSV = async (filters) => {
  // Utilizza direttamente il payload ricevuto, aggiungendo solo page e pageSize
  const requestBody = {
    ...filters, // Prendi esattamente tutti i campi
    page: 1,
    pageSize: 10000,
  };

  console.log("Payload finale per il CSV:", requestBody);

  const response = await apiFetch("/nodeapi/backorders", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(requestBody),
  });
       if (response.status === 401 || response.status === 403 || response.status === 500) {
        handleLogout();
        return;
      }

  if (!response.ok) {
    console.error("Errore:", response.statusText);
    throw new Error("Errore durante il download CSV");
  }

  const result = await response.json();
  const decrypted = await decryptData(result.encryptedData, result.encryptedKey, result.iv);
  const decryptedJson = JSON.parse(decrypted);

  if (!decryptedJson.data || decryptedJson.data.length === 0) {
    console.warn("⚠️ Nessun dato disponibile per CSV.");
    return;
  }

  const headers = Object.keys(decryptedJson.data[0]).join(";");
  const csvRows = decryptedJson.data.map((row) => 
    Object.values(row).map(val => `"${val}"`).join(";")
  );

  const csvString = [headers, ...csvRows].join("\r\n");

  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const filename = `backorders_${new Date().toISOString().slice(0, 10)}.csv`;
  
  // Use mobile-compatible download method
  downloadFileWithMobileSupport(blob, filename);
};
